import Vue from 'vue'
import Vuex from 'vuex'
import { IS_DEV } from '@/util/globals'
import pathify from '@/plugins/vuex-pathify'
import { attachStorePersistence, hydrateDashboardSignals } from './persistence'
import { startStoreRefreshScheduler } from './refreshScheduler'

// Modules
import * as modules from './modules'

Vue.use(Vuex)

const HOLD_REFRESHING = false // Hold refreshing data - only for development
// Refreshing data time
const REFRESHING_DATA_TIME = HOLD_REFRESHING && IS_DEV ? 1000000 : 5000 // 5 seconds or 1000 seconds

const store = new Vuex.Store({
  modules,
  plugins: [
    pathify.plugin,
  ],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  strict: IS_DEV
})

hydrateDashboardSignals(store)
attachStorePersistence(store)

store.dispatch('app/init')
store.dispatch('auth/init')
store.dispatch('payments/init');

export default store
startStoreRefreshScheduler(store, REFRESHING_DATA_TIME)

export const ROOT_DISPATCH = Object.freeze({ root: true })